import { render, staticRenderFns } from "./ProfileCardHorizontal.vue?vue&type=template&id=4ce20804&"
import script from "./ProfileCardHorizontal.vue?vue&type=script&lang=js&"
export * from "./ProfileCardHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports